import React from 'react';
import { useMediaQuery } from 'react-responsive';
import WebHostingContent from './WebHostingContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <WebHostingContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
